import { render, staticRenderFns } from "./VoiceCallLogList.vue?vue&type=template&id=48b54146&scoped=true&"
import script from "./VoiceCallLogList.vue?vue&type=script&lang=js&"
export * from "./VoiceCallLogList.vue?vue&type=script&lang=js&"
import style0 from "./VoiceCallLogList.vue?vue&type=style&index=0&id=48b54146&lang=scss&scoped=true&"
import style1 from "./VoiceCallLogList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b54146",
  null
  
)

export default component.exports